module.exports = __webpack_public_path__ + "static/media/spells-cast-mockup.72d34eb7.png";